import { useRef, useState } from 'react'

import { Text, TextProps, Tooltip, useTooltip } from '@revolut-internal/ui-kit'

import { FCWithChildren } from 'modules/Monitoring/types'

type EllipsisTextProps = FCWithChildren<TextProps>

export const EllipsisText: EllipsisTextProps = ({ children, ...props }) => {
  const ref = useRef<HTMLSpanElement>(null)
  const [isTextTruncated, setIsTextTruncated] = useState<boolean>(true)
  const [width, setWidth] = useState<number>(0)

  const tooltip = useTooltip<HTMLSpanElement>()
  const anchorProps = tooltip.getAnchorProps({ ref })

  const handleMouseEnter = event => {
    const target = event.currentTarget

    setWidth(target.clientWidth)
    setIsTextTruncated(target.scrollWidth > target.clientWidth)
  }

  return (
    <>
      <Text
        {...props}
        {...anchorProps}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        onMouseEnter={event => {
          anchorProps.onMouseEnter()
          handleMouseEnter(event)
        }}
      >
        {children}
      </Text>
      <Tooltip
        {...tooltip.getTargetProps({
          open: isTextTruncated,
          placement: 'bottom-start',
          maxWidth: Math.max(width, 320),
        })}
      >
        {ref.current?.textContent}
      </Tooltip>
    </>
  )
}
